<template>
    <div
        class="flex items-start transition-all py-2"
        :class="{ 'cursor-pointer': !isActive }"
        :style="{'gap': isActive ? '8px' : '4px'}"
    >
        <span
            class="font transition-all duration-500 font-manrope tracking-[-0.75px]"
            :class="isActive ? 'text-[28px] leading-9 font-extrabold' : 'text-xl leading-7 font-semibold'"
            style="color: #FF4F66;"
        >
            {{ number }}.
        </span>
        <div
            class="flex flex-col grow transition-all duration-500"
            :style="{
                'gap': isActive ? '24px' : '8px',
                'color': isActive ? '#141414' : '#545454'
            }"
        >
            <div
                class="flex flex-col transition-all duration-300"
                :style="{'gap': isActive ? '8px' : '4px'}"
            >
                <span
                    class="font transition-all duration-300 font-manrope tracking-[-0.75px]"
                    :class="isActive ? 'text-[28px] leading-9 font-extrabold' : 'text-xl leading-7 font-semibold'"
                >
                    {{ title }}
                </span>
                <span
                    class="font font-normal transition-all duration-300 font-manrope"
                    :class="isActive ? 'text-base leading-6' : 'text-sm leading-5'"
                >
                    {{ description }}
                </span>
            </div>
            <UProgress
                v-if="isActive"
                :model-value="percentage"
                :max="100"
                :ui="{
                    root: 'h-px',
                    base: 'bg-gray-200',
                    indicator: 'bg-gray-400'
                }"
                size="xs"
            />
            <div
                v-if="!isActive && !isLastItem"
                class="h-px bg-[#E3E3E3] w-full"
            />
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';

export default {
    name: 'HowItWorksItem',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        progress: {
            type: Number,
            default: 0,
        },
        isLastItem: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        percentage() {
            if (!this.isActive) return 0;
            return Math.max(0, Math.min(100, Number(this.progress) || 0));
        },
        number() {
            return String(this.item.id).padStart(2, '0');
        },
        title() {
            return get(this.item, 'title');
        },
        description() {
            return get(this.item, 'description');
        },
    },
};
</script>

